const content = {
  title: "Choosing Between Present Perfect and Past Simple",
  explanation: `
At B1 level, the challenge is often not grammar form, but grammar choice in context.
Example: I have read that book. / I read that book last month.

Choose Present Perfect when discussing experience or change connected to now.
Example: He has worked in three countries.

Choose Past Simple when the sentence includes a completed time reference.
Example: He worked in Spain in 2018.

To decide correctly, identify the time logic before speaking.
Example: Have you seen this film? / Yes, I saw it on Friday.
  `,
  rules: [
    "Use Present Perfect to talk about experiences without saying when",
    "Use Past Simple when the time is mentioned or clearly finished",
    "Time words like yesterday, last week, and in 2020 require Past Simple",
    "Words like ever, never, and before are often used with Present Perfect",
    "Always ask: Is the time important or finished?"
  ],
  examples: [
    "I have seen this movie before. (experience)",
    "I saw this movie last night. (finished time)",
    "She has never traveled abroad. (life experience)",
    "She traveled abroad in 2018. (specific time)",
    "Have you ever tried sushi?"
  ]
};

export default content;


